import { translate, translationKeys } from 'logic/translations/translations.service';
import { PricingModel } from './my-pricing.model';

export const DEFAULT_PRESELECTED_LESSONUNIT_COUNT = 8;
export const pricingModelList: PricingModel[] = [
  {
    title: translate(translationKeys.pricing.pricingModel.item1.title),
    lessonPerWeek: '1',
    description: translate(translationKeys.pricing.pricingModel.item1.description),
    preSelectedlessonUnitCount: 4,
    gradeGuarantee: false,
  },
  {
    title: translate(translationKeys.pricing.pricingModel.item2.title),
    lessonPerWeek: '2',
    description: translate(translationKeys.pricing.pricingModel.item2.description),
    preSelectedlessonUnitCount: 8,
    mostSold: true,
    gradeGuarantee: true,
  },
  {
    title: translate(translationKeys.pricing.pricingModel.item3.title),
    lessonPerWeek: '3',
    description: translate(translationKeys.pricing.pricingModel.item3.description),
    preSelectedlessonUnitCount: 12,
    gradeGuarantee: true,
  },
  {
    title: translate(translationKeys.pricing.pricingModel.item4.title),
    lessonPerWeek: null,
    description: translate(translationKeys.pricing.pricingModel.item4.description),
    preSelectedlessonUnitCount: null,
    gradeGuarantee: true,
  },
];
